import { Compass } from "lucide-react";
import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideAssistantProps {
    onClose: () => void;
}

export const HelpGuideAssistant = ({ onClose }: HelpGuideAssistantProps) => {
    return (
        <div>
            <ModalHeader
                title="Using the Assistant"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The Assistant tab provides key insights on how to complete
                    your resume. Select the Assistant icon (
                    <Compass
                        size={16}
                        className="mb-1 inline-block"
                    />
                    ) in the sidebar and toggle between &apos;Resume&apos; and
                    &apos;Section&apos;.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The Resume tab will automatically be selected. You can
                    scroll down and use the accordions to expand each
                    sub-heading.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    To use the Section tab, select a section to view further
                    information. You will need to select a Section in order for
                    the insights to appear.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
